import { render, staticRenderFns } from "./ModelPage.vue?vue&type=template&id=4fabd11d"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"
import style0 from "./ModelPage.vue?vue&type=style&index=0&id=4fabd11d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports